import { render, staticRenderFns } from "./AddClassModal.vue?vue&type=template&id=6f84a1a2&scoped=true&"
import script from "./AddClassModal.vue?vue&type=script&lang=js&"
export * from "./AddClassModal.vue?vue&type=script&lang=js&"
import style0 from "./AddClassModal.vue?vue&type=style&index=0&id=6f84a1a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84a1a2",
  null
  
)

export default component.exports